import { AgeGroup } from '../types/domain';

export type BodySide = 'front' | 'back';
export type GlucoseZone = 'low' | 'normal' | 'warning' | 'high';

export interface InjectionSite {
  id: number;
  label: string;
  side: BodySide;
  x: number;
  y: number;
}

export const kidsSites: InjectionSite[] = [
  { id: 1, label: 'Lengan Atas Kanan: 1/3 Atas sisi luar', side: 'front', x: 22, y: 30 },
  { id: 2, label: 'Lengan Atas Kiri: 1/3 Atas sisi luar', side: 'front', x: 78, y: 30 },
  { id: 3, label: 'Perut Kanan Atas', side: 'front', x: 44, y: 45 },
  { id: 4, label: 'Perut Kiri Atas', side: 'front', x: 56, y: 45 },
  { id: 5, label: 'Paha Kanan: 1/3 Atas Sisi Luar', side: 'front', x: 40, y: 65 },
  { id: 6, label: 'Paha Kiri: 1/3 Atas Sisi Luar', side: 'front', x: 60, y: 65 },
  { id: 7, label: 'Lengan Atas Kanan: 1/3 Tengah sisi luar', side: 'front', x: 22, y: 40 },
  { id: 8, label: 'Lengan Atas Kiri: 1/3 Tengah sisi luar', side: 'front', x: 78, y: 40 },
  { id: 9, label: 'Perut Kanan Bawah', side: 'front', x: 44, y: 55 },
  { id: 10, label: 'Perut Kiri Bawah', side: 'front', x: 56, y: 55 },
  { id: 11, label: 'Paha Kiri: 1/3 Tengah Sisi Luar', side: 'front', x: 60, y: 75 },
  { id: 12, label: 'Paha Kanan: 1/3 Tengah Sisi Luar', side: 'front', x: 40, y: 75 },
  { id: 13, label: 'Lengan Atas Kanan: 1/3 Atas sisi belakang', side: 'back', x: 22, y: 30 },
  { id: 14, label: 'Lengan Atas Kiri: 1/3 Atas sisi belakang', side: 'back', x: 78, y: 30 },
  { id: 15, label: 'Bokong Kanan: Bagian sisi luar atas', side: 'back', x: 44, y: 65 },
  { id: 16, label: 'Bokong Kiri: Bagian sisi luar atas', side: 'back', x: 56, y: 65 },
  { id: 17, label: 'Lengan Atas Kanan: 1/3 Tengah sisi belakang', side: 'back', x: 22, y: 40 },
  { id: 18, label: 'Lengan Atas Kiri: 1/3 Tengah sisi belakang', side: 'back', x: 78, y: 40 }
];

export const teenSites: InjectionSite[] = [
  { id: 1, label: 'Lengan Atas Kanan: 1/3 Atas sisi luar', side: 'front', x: 22, y: 30 },
  { id: 2, label: 'Lengan Atas Kiri: 1/3 Atas sisi luar', side: 'front', x: 78, y: 30 },
  { id: 3, label: 'Perut Kanan Atas', side: 'front', x: 44, y: 45 },
  { id: 4, label: 'Perut Kiri Atas', side: 'front', x: 56, y: 45 },
  { id: 5, label: 'Paha Kanan: 1/3 Atas Sisi Luar', side: 'front', x: 40, y: 65 },
  { id: 6, label: 'Paha Kiri: 1/3 Atas Sisi Luar', side: 'front', x: 60, y: 65 },
  { id: 7, label: 'Lengan Atas Kanan: 1/3 Tengah sisi luar', side: 'front', x: 22, y: 40 },
  { id: 8, label: 'Lengan Atas Kiri: 1/3 Tengah sisi luar', side: 'front', x: 78, y: 40 },
  { id: 9, label: 'Perut Kanan Bawah', side: 'front', x: 44, y: 55 },
  { id: 10, label: 'Perut Kiri Bawah', side: 'front', x: 56, y: 55 },
  { id: 11, label: 'Paha Kanan: 1/3 Tengah Sisi Luar', side: 'front', x: 40, y: 75 },
  { id: 12, label: 'Perut Tengah Atas (Hindari Area Dekat Pusar)', side: 'front', x: 50, y: 50 },
  { id: 13, label: 'Paha Kiri: 1/3 Tengah Sisi Luar', side: 'front', x: 60, y: 75 },
  { id: 14, label: 'Perut Tengah Bawah (Hindari Area Dekat Pusar)', side: 'front', x: 50, y: 60 },
  { id: 15, label: 'Lengan Atas Kanan: 1/3 Atas sisi belakang', side: 'back', x: 22, y: 30 },
  { id: 16, label: 'Lengan Atas Kiri: 1/3 Atas sisi belakang', side: 'back', x: 78, y: 30 },
  { id: 17, label: 'Bokong Kanan: Bagian sisi luar atas', side: 'back', x: 44, y: 65 },
  { id: 18, label: 'Bokong Kiri: Bagian sisi luar atas', side: 'back', x: 56, y: 65 },
  { id: 19, label: 'Lengan Atas Kanan: 1/3 Tengah sisi belakang', side: 'back', x: 22, y: 40 },
  { id: 20, label: 'Lengan Atas Kiri: 1/3 Tengah sisi belakang', side: 'back', x: 78, y: 40 }
];

export function getSitesForAge(ageGroup: AgeGroup | null): InjectionSite[] {
  if (ageGroup === '2-10') {
    return kidsSites;
  }
  if (ageGroup === '11-plus') {
    return teenSites;
  }
  return [];
}

export function getSuggestedSiteCount(ageGroup: AgeGroup | null): number {
  if (ageGroup === '2-10') {
    return kidsSites.length;
  }
  if (ageGroup === '11-plus') {
    return teenSites.length;
  }
  return 0;
}

export function getGlucoseTypeOptions(ageGroup: AgeGroup | null): { id: string; label: string }[] {
  if (ageGroup === '2-10') {
    return [
      { id: 'puasa', label: 'Puasa' },
      { id: 'sebelum', label: 'Sebelum makan' },
      { id: '2jam', label: '2 jam setelah makan' },
      { id: 'sewaktu', label: 'Sewaktu' }
    ];
  }
  return [
    { id: 'puasa', label: 'Puasa' },
    { id: 'sebelum', label: 'Sebelum makan' },
    { id: 'sesudah', label: 'Setelah makan' },
    { id: 'sewaktu', label: 'Sewaktu' }
  ];
}

export function getInsulinTypeOptions(): { id: string; label: string }[] {
  return [
    { id: 'basal-malam', label: 'Basal malam' },
    { id: 'basal-pagi', label: 'Basal pagi' },
    { id: 'pre-sarapan', label: 'Sebelum makan sarapan' },
    { id: 'pre-siang', label: 'Sebelum makan siang' },
    { id: 'pre-malam', label: 'Sebelum makan malam' },
    { id: 'koreksi', label: 'Ekstra / koreksi' }
  ];
}

export function getSiteClass(
  site: InjectionSite,
  suggestedSiteId: number | null,
  selectedSiteId: number | null
): string {
  const classes = ['site-dot'];
  if (site.id === suggestedSiteId) {
    classes.push('suggested');
  }
  if (site.id === selectedSiteId) {
    classes.push('selected');
  }
  return classes.join(' ');
}

export function getGlucoseStatusText(zone: GlucoseZone | null): string | null {
  if (zone === 'low') {
    return 'Glukosa darah rendah, makan/minum yang manis dan cek lagi.';
  }
  if (zone === 'normal') {
    return 'Glukosa darah aman, perhatikan dosis insulin sebelum makan.';
  }
  if (zone === 'warning') {
    return 'Perhatikan dosis insulin sesuai anjuran dokter.';
  }
  if (zone === 'high') {
    return 'Glukosa darah tinggi, perhatikan dosis insulin sesuai anjuran dokter.';
  }
  return null;
}

export function getAgeGroupLabel(ageGroup: AgeGroup): string {
  if (ageGroup === '2-10') {
    return '2–10 tahun';
  }
  return '≥11 tahun';
}

export function getInsulinTypeLabel(id: string | null): string {
  if (!id) {
    return 'Tidak tercatat';
  }
  const options = getInsulinTypeOptions();
  const match = options.find(option => option.id === id);
  if (!match) {
    return 'Tidak dikenali';
  }
  return match.label;
}

export function getSiteLabelForHistory(ageGroup: AgeGroup, siteId: number | null): string {
  if (siteId === null) {
    return 'Cek Gula Darah Saja';
  }
  const sites = getSitesForAge(ageGroup);
  const match = sites.find(site => site.id === siteId);
  if (!match) {
    return `Lokasi ${siteId}`;
  }
  return `${match.id}: ${match.label}`;
}

export function getDateTimeValue(date: string, time: string): number {
  const iso = `${date}T${time || '00:00'}`;
  const value = Date.parse(iso);
  if (Number.isNaN(value)) {
    return 0;
  }
  return value;
}

export function formatDateTime(date: string, time: string): string {
  if (!date && !time) {
    return 'Tidak tercatat';
  }
  if (!date) {
    return time;
  }
  if (!time) {
    return date;
  }
  return `${date} ${time}`;
}
